// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7eCtz","questions":"styles_questions__2I_lM","footer":"styles_footer__3fb-x"};